import { createSlice, current } from "@reduxjs/toolkit";
import { ThunkAction, User } from "../types/index.js";
import { copiedModuleClipboard } from "../utils/utils.js";
import { postLogin } from "./login.js";

export const getUserFromStorage = (): User => {
  try {
    const userPayload = window.localStorage.getItem("user");
    if (!userPayload) {
      throw Error();
    }
    return JSON.parse(userPayload);
  } catch {
    return {};
  }
};

const initialState = getUserFromStorage();

export const doLogoutUser = (): ThunkAction<void> => (dispatch) => {
  copiedModuleClipboard.clear();
  dispatch(logoutUser());
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    logoutUser: (state) => {
      state.token = undefined;
      window.localStorage.setItem("user", JSON.stringify(current(state)));
    },
  },
  extraReducers: (builder) => {
    builder.addCase(postLogin.fulfilled, (_state, action) => action.payload);
  },
});

export const { logoutUser } = userSlice.actions;

export default userSlice.reducer;
